import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Copy, Icon } from '@elparking/components'

import { Events } from 'commons/js/services/analytics'

import PlugsTypes from './PlugsTypes'
import ChargingPointSpeed from 'commons/js/components/ChargingPointSpeed'
import Distance from '../Distance'

import {
    ChargingPointAddressBlock,
    ChargingPointTextBlock,
    Card,
    PlugsContainer,
    CardContainer,
    ChargingPointTextBlockHeader,
} from './layout'

const MAX_PLUGS = 7

class ChargingPointCard extends React.PureComponent {
    static propTypes = {
        chargingPoint: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            address: PropTypes.string,
            plugs: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
                slug: PropTypes.string,
                speedChargingType: PropTypes.number,
            })),
            longitude: PropTypes.number,
            latitude: PropTypes.number,
            power: PropTypes.number,
        }),
        distance: PropTypes.any,
        isSelected: PropTypes.bool,
        isMarked: PropTypes.bool,
        onMark: PropTypes.func,
    }

    static defaultProps = {
        buildChargingPointUrl: () => '',
        isMarked: false,
        isSelected: false,
        onMark: () => {},
    }

    render () {
        const { chargingPoint, distance, isSelected, isMarked, onMark } = this.props
        const { name, address, plugs, power } = chargingPoint

        return (
            <Card
              background='main20'
              isSelected={isSelected}
              isMarked={isMarked}
              dataTest={`charging-point-card-${chargingPoint.id}`}
              data-event={Events.chargingPointSearchItemSelect}
              onClick={onMark}
            >
                <CardContainer>
                    <ChargingPointTextBlock>
                        <ChargingPointTextBlockHeader>
                            <Flex justifyContent='space-between'>
                                <Copy.clamp lines='1' fontWeight='book' fontSize='medium' padding='4px 4px 0 0' color={isMarked ? 'gray' : 'main' }>
                                    {name}
                                </Copy.clamp >
                                <Icon type='right' size='xLarge' color={isMarked ? 'gray20' : 'main'} />
                            </Flex>
                            <ChargingPointAddressBlock>
                                <Box m='4px 0 0 0'>
                                    <Copy fontWeight='regular' padding='0'>
                                        {address}<Distance distance={distance} />
                                    </Copy>
                                </Box>
                            </ChargingPointAddressBlock>
                        </ChargingPointTextBlockHeader>
                        <ChargingPointSpeed maxPower={power} plugs={plugs} />
                        <PlugsContainer>
                            <PlugsTypes plugs={plugs} max={MAX_PLUGS} />
                        </PlugsContainer>
                    </ChargingPointTextBlock>
                </CardContainer>
            </Card>
        )
    }
}

export default ChargingPointCard
